<script lang="ts">
  import { useHelp } from '@/ui/components/dialogs/use-help.svelte';
  import { useTeoCore } from '@/utils/teo-context';

  import HelpOverlay from './cmps/HelpOverlay.svelte';

  let help = useHelp();
  let core = useTeoCore();

  function handleClose() {
    core?.help.close();
  }
</script>

<HelpOverlay helpData={help.current} onClose={handleClose} />
